import apiSkobo from "@/helpers/api/apiSkobo";

export const sensitivityLabels_actions = {
  setupSensitivityLabels(sensitivityLabels) {
    sensitivityLabels.forEach(label => {
      const lbl = JSON.parse(label.value);
      this.sensitivityLabelsState[label.key] = lbl;
    });
  },

  async createSensitivityLabel(sensitivityLabel) {
    const sensitivityLabelDto = {
      key: sensitivityLabel.label.toLowerCase(),
      value: JSON.stringify(sensitivityLabel)
    };

    await apiSkobo
      .post("/me/setup/sensitivityLabel", sensitivityLabelDto)
      .then(() => {
        const labels = Object.assign({}, this.sensitivityLabelsState);
        labels[sensitivityLabel.label.toLowerCase()] = sensitivityLabel;
        this.sensitivityLabelsState = labels;
      })
      .catch(() => {});
  },

  async deleteSensitivityLabel(sensitivityLabel) {
    await apiSkobo
      .delete(`/me/setup/SensitivityLabel/${sensitivityLabel.label.toLowerCase()}`)
      .then(() => {
        const labels = Object.assign({}, this.sensitivityLabelsState);
        delete labels[sensitivityLabel.label.toLowerCase()];
        this.sensitivityLabelsState = labels;
      })
      .catch(() => {});
  }
};

export const sensitivityLabels_getters = {
  sensitivityLabels: state => state.sensitivityLabelsState
};

export const sensitivityLabels_state = {
  sensitivityLabelsState: {}
};
